module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "text-container valign"
  }, [_c('h3', {
    staticClass: "text-title__big"
  }, [_vm._v("ТЕСТ НА BBQ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaClickNext($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "decoration-container decoration-container__main"
  }, [_c('div', {
    staticClass: "layer layer__1",
    style: ({
      transform: 'rotate(-' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "circle"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__2",
    style: ({
      transform: 'rotate(' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-1",
    attrs: {
      "src": "/static/images/grill.png",
      "alt": "Grill"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-2",
    attrs: {
      "src": "/static/images/item-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-3",
    attrs: {
      "src": "/static/images/item-3-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-4",
    attrs: {
      "src": "/static/images/item-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-5",
    attrs: {
      "src": "/static/images/item-4-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-6",
    attrs: {
      "src": "/static/images/item-5.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-7",
    attrs: {
      "src": "/static/images/item-6.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    staticClass: "i-8",
    attrs: {
      "src": "/static/images/item-7.png",
      "alt": "Item"
    }
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Планируете провести выходные с шампуром в руке? Ждете вечер пятницы, чтобы отправиться на дачу и жарить там стейки до воскресенья?\n            Неплохой план, однако к нему стоит подготовиться заранее, чтобы ваш организм не испытал белковую (и не только) перегрузку.\n            Узнайте о том, какие рецепты вам подойдут, а также\n            о мерах, которые стоит принять, если мяса окажется"), _c('br', {
    staticClass: "mobile-hidden"
  }), _vm._v(" слишком много.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba788848"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Index.vue
// module id = 106
// module chunks = 0